interface PinIconProps {
  className?: string;
  /** Filled while the Thread is pinned. */
  filled?: boolean;
}

/**
 * A pin (F44, as T3 Code's sidebar has it): Lucide's `pin`, from `lucide-icons/lucide` (ISC,
 * © Lucide Contributors), the icon set T3 Code uses. Heroicons, the app's set, has none. It
 * takes the text colour.
 */
export default function PinIcon({ className = "h-4 w-4", filled = false }: PinIconProps) {
  return (
    <svg viewBox="0 0 24 24" fill={filled ? "currentColor" : "none"} stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className={className}>
      <path d="M12 17v5" />
      <path d="M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z" />
    </svg>
  );
}
